"use client"

import { useState } from "react"
import { Ghost } from "lucide-react"

export function ReportGhostButton({
  residencyId,
  isLoggedIn,
}: {
  residencyId: string
  isLoggedIn: boolean
}) {
  const [state, setState] = useState<"idle" | "confirm" | "sending" | "sent" | "error">("idle")

  async function handleReport() {
    if (!isLoggedIn) {
      window.location.href = "/login?callbackUrl=" + encodeURIComponent(window.location.pathname)
      return
    }
    if (state === "idle") {
      setState("confirm")
      return
    }
    if (state === "confirm") {
      setState("sending")
      try {
        const res = await fetch("/api/reports/ghost", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ residencyId }),
        })
        if (!res.ok) throw new Error()
        setState("sent")
      } catch {
        setState("error")
        setTimeout(() => setState("idle"), 3000)
      }
    }
  }

  if (state === "sent") {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs text-[var(--accent)]">
        <Ghost size={14} />
        Reported — thank you!
      </span>
    )
  }

  if (state === "confirm") {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs">
        <Ghost size={14} className="text-orange-600" />
        <button
          onClick={handleReport}
          className="text-orange-600 hover:text-orange-800 font-medium transition-colors"
        >
          Confirm report?
        </button>
        <button
          onClick={() => setState("idle")}
          className="text-[var(--muted-foreground)] hover:text-[var(--foreground)] transition-colors"
        >
          Cancel
        </button>
      </span>
    )
  }

  return (
    <button
      onClick={handleReport}
      className="inline-flex items-center gap-1.5 text-xs text-[var(--muted-foreground)] hover:text-orange-600 transition-colors"
      title="Report this listing as inactive or closed"
    >
      <Ghost size={14} />
      <span>{state === "error" ? "Failed — try again" : "Report a Ghost"}</span>
    </button>
  )
}
